import React from 'react';
import EsDeskMonitor from './EsDeskMonitor';
// SATURN — overnight ES LONG (NQ below-SMA). Grade B.
export default function SaturnMonitor() { return <EsDeskMonitor system="saturn" accent="#0ea5e9" />; }
